import React from 'react';
import { Box, Typography } from '@mui/material';
import { isMobile } from 'react-device-detect';

interface MobileBlockerProps {
  children: React.ReactNode;
}

/**
 * Компонент блокировки доступа с мобильных устройств
 * Использует react-device-detect для надежного определения
 */
const MobileBlocker: React.FC<MobileBlockerProps> = ({ children }) => {
  if (isMobile) {
    return (
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: 'background.default',
          p: 2
        }}
      >
        <Typography variant="h5" color="text.secondary" fontWeight="bold">
          Доступ заблокирован
        </Typography>
      </Box>
    );
  }

  return <>{children}</>;
};

export default MobileBlocker;

